import { axios } from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'
import { Project } from '../types'

const getProjectById = (projectId: string): Promise<Project> => {
  return axios.get(`/projects?projectId=${projectId}`)
}

export const useProjectById = (projectId: string) => {
  return useQuery({
    queryKey: ['project', projectId],
    queryFn: () => getProjectById(projectId),
  })
}
